<template>
    <div>
        <div class="form-group">
            <label for="full_name">{{ $t('pages.subscription.start.address.full_name') }}</label>
            <input type="text" class="form-control" id="full_name" :placeholder="$t('pages.subscription.start.address.full_name')"  v-model="$attrs.value.full_name"
                   :class="{'is-invalid': $errors.has(validationNamePrefix + 'full_name')}"> <!-- @keyup="$emit('update:address', localAddress) -->
            <error :input="validationNamePrefix + 'full_name'"/>
        </div>

        <div class="form-group">
            <label for="address_one">{{ $t('pages.subscription.start.address.address_one') }}</label>
            <input type="text" class="form-control" id="address_one" :placeholder="$t('pages.subscription.start.address.address_one')"  v-model="$attrs.value.address_one"
                   :class="{'is-invalid': $errors.has(validationNamePrefix + 'address_one')}"> <!-- @keyup="$emit('update:address', localAddress) -->
            <error :input="validationNamePrefix + 'address_one'"/>
        </div>
        <div class="form-group">
            <label for="address_two">{{ $t('pages.subscription.start.address.address_two') }}</label>
            <input type="text" class="form-control" id="address_two" :placeholder="$t('pages.subscription.start.address.address_two')"  v-model="$attrs.value.address_two"
                   :class="{'is-invalid': $errors.has(validationNamePrefix + 'address_two')}"> <!-- @keyup="$emit('update:address', localAddress) -->
            <error :input="validationNamePrefix + 'address_two'"/>
        </div>

        <div class="row">
            <div class="col-6">
                <div class="form-group">
                    <label for="city">{{ $t('pages.subscription.start.address.city') }}</label>
                    <input type="text" class="form-control" id="city" :placeholder="$t('pages.subscription.start.address.city')"  v-model="$attrs.value.city"
                           :class="{'is-invalid': $errors.has(validationNamePrefix + 'city')}"> <!-- @keyup="$emit('update:address', localAddress) -->
                    <error :input="validationNamePrefix + 'city'"/>
                </div>
            </div>
            <div class="col-6">
                <div class="form-group">
                    <label for="postal_code">{{ $t('pages.subscription.start.address.postal_code') }}</label>
                    <input type="text" class="form-control" id="postal_code" :placeholder="$t('pages.subscription.start.address.postal_code')"  v-model="$attrs.value.postal_code"
                           :class="{'is-invalid': $errors.has(validationNamePrefix + 'postal_code')}"> <!-- @keyup="$emit('update:address', localAddress) -->
                    <error :input="validationNamePrefix + 'postal_code'"/>
                </div>
            </div>
        </div>

        <!-- User can select country -->
        <div class="form-group" v-if="!luxOnly">
            <label for="country_id">{{ $t('pages.subscription.start.address.country') }}</label>
            <select class="form-control" id="country_id" :placeholder="$t('pages.subscription.start.address.country')"  v-model="$attrs.value.country_id"
                    :class="{'is-invalid': $errors.has(validationNamePrefix + 'country_id')}"> <!-- @keyup="$emit('update:address', localAddress) -->
                <option :value="country.id" v-for="country in countryList">
                    {{ country.name }}
                </option>
            </select>
            <error :input="validationNamePrefix + 'country'"/>
        </div>

        <!-- user is forced to take luxembourg -->
        <div class="form-group" v-else-if="luxOnly">
            <label for="country_id">{{ $t('pages.subscription.start.address.country') }}</label>
            <select class="form-control disabled" disabled="disabled" id="country_id" :placeholder="$t('pages.subscription.start.address.country')"  v-model="$attrs.value.country_id">
                <option :value="country.id" v-for="country in countryList">
                    {{ country.name }}
                </option>
            </select>
        </div>

    </div>
</template>

<script>
import CountryRepository from "../../../../repositories/Countries/CountryRepository";

export default {
    name: "AddressForm",
    props: {
      countries: {
          type: Array,
          default: () => []
      },
        validationNamePrefix: {
          type: String,
          default: ''
      },
        luxOnly: {
            type: Boolean,
            default: false,
        }
    },
    mounted() {
        if(!this.countries.length)
            CountryRepository
                .getSimple()
                .then((res) => this.countriesLoadedByComponent = res.data);

        if(this.$attrs.value.country_id === undefined) {
            this.$attrs.value.country_id = 442;
        }

    },
    computed: {
        countryList() {
            if(!this.countries.length)
                return this.countriesLoadedByComponent;

            return this.countries;
        }
    },
    data: () => ({
        localAddress: {
            full_name: '',
            address_one: '',
            address_two: '',
            city: '',
            postal_code: '',
            country_id: 442,
        },

        countriesLoadedByComponent: [],
    })
}
</script>

<style scoped>

</style>
